module.exports = __webpack_public_path__ + "d4d0151f9e100e32c62a8405b152a14b.png";